export default "__VITE_ASSET__H7WAdl1f__"